import React from 'react';

const stackGroups = [
  { label: 'backend', items: ['.NET 8', 'ASP.NET Core', 'SQL Server', 'Postgres'] },
  { label: 'frontend', items: ['React', 'TypeScript', 'Tailwind CSS'] },
  { label: 'platform', items: ['Docker', 'Azure'] },
];

export const Expertise: React.FC = () => {
  return (
    <section id="expertise" className="py-32 bg-background relative border-t border-gray-100">
      <div className="max-w-7xl mx-auto px-6">
        <div className="mb-16">
          <span className="text-syntaxComment font-mono text-sm font-medium">{'// Dependency[]'}</span>
          <h2 className="font-display text-4xl font-bold text-gray-900 mt-1">Stack</h2>
        </div>

        <div className="bg-white rounded-lg border border-gray-200 shadow-xl overflow-hidden font-mono code-shadow">
          <div className="bg-gray-50 px-4 py-2 flex items-center justify-between border-b border-gray-200">
            <span className="text-xs text-gray-500">src/stack.ts</span>
            <span className="text-xs text-gray-400">UTF-8</span>
          </div>
          <div className="p-6 text-gray-800 leading-relaxed syntax-highlight">
            <span className="text-syntaxKeyword font-bold">export const</span>{' '}
            <span className="text-syntaxVariable font-semibold">stack</span> = [
            <br />
            {stackGroups.flatMap((group, groupIndex) => [
              <span key={`${group.label}-comment`} className="block">
                &nbsp;&nbsp;<span className="text-syntaxComment">{`// ${group.label}`}</span>
              </span>,
              ...group.items.map((item) => (
                <span key={item} className="block">
                  &nbsp;&nbsp;<span className="text-syntaxString">"{item}"</span>,
                </span>
              )),
              groupIndex === stackGroups.length - 1 ? null : <br key={`${group.label}-spacer`} />,
            ])}
            <span className="block">];</span>
          </div>
        </div>
      </div>
    </section>
  );
};
